
import Vue from 'vue';

export default Vue.extend({
  name: 'InputPhoneNumber',
  props: {
    error: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  data() {
    return {
      phoneNumber: null,
    }
  },
  methods: {
    handleUpdate(e: any) {
      if (e.isValid) {
        const number = e.e164.replace(/\+/g, '00');
        this.$emit('updatePhoneNumber', number)
      } else {
        this.$emit('updatePhoneNumber', '')
      }
    }
  }
})
